import { createFileRoute, notFound } from "@tanstack/react-router";

import { hasPermission } from "@blis/shared/permissions";

export const Route = createFileRoute("/_auth/admin")({
  beforeLoad: ({ context }) => {
    if (!hasPermission(context.user.role, "admin:all")) {
      throw notFound();
    }
  },
});
